import styled from 'styled-components';

const EllipsisTooltipDescription = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #ededed5e;
  `;

const EllipsisText = styled.div`
  width: ${props => props.width || 300}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  `;

export default {
  EllipsisTooltipDescription,
  EllipsisText,
};
